import React from 'react';

const Label = ({ label, bold, asterisk, id, customClass = '' }) => {
  return (
    <div className={bold ? 'text-bold font-size-16 mb-2':  `custom-field-label ${customClass}`} id={id}>
      {label}
      {asterisk && label && <span className="color-asterisk">{' *'}</span>}
    </div>
  );
};

export default Label;